module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "ds-agenda-event",
    class: _vm.classes
  }, [(_vm.first) ? _c('td', {
    staticClass: "ds-agenda-lines",
    attrs: {
      "rowspan": _vm.siblings
    }
  }, [_vm._t("agendaDayDate", [_c('div', {
    staticClass: "ds-agenda-line-first"
  }, [_vm._v("\n        " + _vm._s(_vm.firstLine) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "ds-agenda-line-second",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.viewDay($event)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.secondLine) + "\n      ")])], null, _vm.slotData)], 2) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "ds-agenda-when",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("agendaEventWhen", [_vm._v("\n\n      " + _vm._s(_vm.when) + "\n\n    ")], null, _vm.slotData)], 2), _vm._v(" "), _c('td', {
    staticClass: "ds-agenda-details",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editCheck($event)
      }
    }
  }, [_c('v-menu', _vm._b({
    staticClass: "ds-calendar-event-menu",
    attrs: {
      "content-class": _vm.contentClass,
      "disabled": !_vm.hasPopover
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, 'v-menu', _vm.popoverProps, false), [_c('div', {
    staticClass: "ds-agenda-activator",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._t("agendaEventDetails", [(_vm.details.icon) ? _c('v-icon', {
    staticClass: "ds-details-icon",
    attrs: {
      "size": "16"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.details.icon) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.details.title)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ds-details-description",
    domProps: {
      "innerHTML": _vm._s(_vm.details.description)
    }
  })], null, _vm.slotData)], 2), _vm._v(" "), _vm._t("eventPopover", null, null, {
    readOnly: _vm.readOnly,
    calendarEvent: _vm.calendarEvent,
    calendar: _vm.calendar,
    edit: _vm.edit,
    details: _vm.details,
    close: _vm.close
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52125556","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AgendaEvent.vue
// module id = 169
// module chunks = 0